import React from "react";
import { HiX } from "react-icons/hi";
import { FiCreditCard } from "react-icons/fi";
import {
  getGatewayLabel,
  getPaymentButtonsForGateway,
} from "utilities/onlinePaymentFlow";
import PaymentModeButtons from "./PaymentModeButtons";

const PaymentGatewayOptions = ({
  gateways = [],
  title = "Select Payment Gateway",
  subtitle = "Choose a device and payment method to continue",
  onSelect,
  onClose,
}) => {
  return (
    <div className="overflow-hidden rounded-b-xl bg-white">
      <div className="relative px-5 py-4 bg-gradient-to-r from-slate-800 to-slate-700 text-white">
        <div className="pr-8">
          <h5 className="text-base text-slate-200 font-semibold tracking-wide">{title}</h5>
          <p className="mt-1 text-xs text-slate-200">{subtitle}</p>
        </div>
        <button
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white/25"
          onClick={onClose}
          aria-label="Close"
        >
          <HiX size={18} />
        </button>
      </div>

      <div className="max-h-[70vh] overflow-y-auto px-4 py-4 space-y-3 bg-slate-50">
        {gateways.length === 0 && (
          <div className="rounded-xl border border-dashed border-slate-300 bg-white px-4 py-8 text-center text-sm text-slate-500">
            No payment gateways available.
          </div>
        )}

        {gateways.map((gateway) => {
          const buttons = getPaymentButtonsForGateway(gateway);

          return (
            <div
              key={gateway?.id}
              className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md"
            >
              <div className="mb-3 flex items-center gap-2 border-b border-slate-100 pb-3">
                
                <div>
                  <div className="text-sm font-semibold text-slate-800">
                    {getGatewayLabel(gateway)}
                  </div>
                  
                </div>
              </div>

              <PaymentModeButtons
                buttons={buttons}
                onSelect={(allowedPaymentMode, payMode) =>
                  onSelect?.(gateway, allowedPaymentMode, payMode)
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentGatewayOptions;
